export {default} from '../../../core/components/Repository/FieldAutocompleteFreeSolo';